@charset "UTF-8";

/* src/app/components/nav-menu/navtrail.component.scss */
.central-objekt {
  color: white;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
}
.flex-container {
  display: flex;
  width: 100%;
}
.flex-item {
  align-self: center;
}
.backdrop-visible {
  z-index: 950;
  position: relative;
}
.breadcrumb {
  margin: 0;
  background-color: transparent;
  padding: 0;
  height: 62px;
}
.breadcrumb-item > a {
  color: white;
}
.breadcrumb-item.black > a {
  color: black;
}
.breadcrumb > li {
  display: flex !important;
  justify-content: center;
  align-items: center;
}
.breadcrumb-item.active {
  color: rgb(82, 168, 219);
}
.breadcrumb-item.active > a {
  color: rgb(82, 168, 219);
}
.vertical-line {
  border-left: 1px solid white;
  height: 36px;
  margin-left: 1px;
  margin-right: 1px;
  margin-top: 2px;
}
li.vertical-line {
  margin-top: 13px;
}
.btn-outline-primary,
.btn-outline-danger,
.btn-outline-success {
  color: #fff !important;
}
.affix {
  top: 0;
  left: 0;
  width: 100%;
}
.dropdown-menu-right {
  right: 0 !important;
  left: auto !important;
}
.dropdown .btn {
  color: #fff;
}
.dropdown-toggle::after {
  display: none;
}
.bold {
  font-weight: bold;
}
.white-background {
  color: black !important;
}
.mat-toolbar {
  background-color: rgb(65, 65, 65);
  font-size: small;
  padding: 0;
}
.mat-mdc-icon-button.disabled mat-icon {
  color: rgb(202, 203, 205);
}
.mat-mdc-icon-button {
  border-radius: 0;
}
div.link:hover {
  cursor: pointer;
}
.burger-menu {
  display: none;
  color: white;
}
@media (max-width: 1130px) {
  .burger-menu {
    display: flex !important;
  }
  .structure-element-filter {
    display: none !important;
  }
  .time-filter {
    display: none !important;
  }
  .action-buttons {
    flex: 8 !important;
  }
  ::ng-deep .filter-menu {
    height: 150px;
    width: 440px;
    max-width: unset;
  }
  ::ng-deep .mat-mdc-menu-panel {
    overflow: unset;
  }
}
.actions {
  align-items: center;
}
.actions li {
  border-right: 1px solid white;
  height: 36px;
}
.actions li:last-of-type {
  border-right: none;
}
.mat-badge-content {
  right: -6px !important;
  top: -6px !important;
  background-color: white;
  color: black;
}
.mat-mdc-icon-button.conflict-warning {
  color: rgb(253, 193, 0);
}
.mat-mdc-icon-button.conflict-error {
  color: #D3394C;
}
.status-button {
  width: 18px;
  height: 80%;
  margin: 2px;
}
.renew {
  color: rgb(253, 193, 0);
}
.clickable:hover {
  opacity: 0.6;
  cursor: pointer;
}
.plan-in-progress {
  background-color: rgb(253, 193, 0);
}
.plan-completed {
  background-color: rgb(186, 211, 26);
}
.plan-release {
  background-color: rgb(0, 151, 109);
}
.focus:hover {
  background-color: #52a8db;
}
.dropdown-menu {
  background-color: rgb(65, 65, 65);
  min-width: unset;
  left: -25px;
  padding: 0;
}
.dropdown-item {
  padding: 8px;
}
.dropdown-button:hover {
  background-color: rgb(96, 174, 222);
}
.buttonList {
  background-color: rgb(65, 65, 65);
  color: white;
  display: inline-flex;
}
mat-button-toggle {
  color: white;
}
.mat-button-toggle-checked {
  color: white;
}
::ng-deep mat-button-toggle.split-button {
  background-color: rgb(65, 65, 65);
}
::ng-deep mat-button-toggle.split-button .mat-button-toggle-appearance-standard .mat-button-toggle-label-content {
  line-height: 24px;
  padding: 0;
}
::ng-deep mat-button-toggle.split-button:hover {
  background-color: rgb(96, 174, 222);
}
::ng-deep mat-button-toggle.drop-down-button {
}
::ng-deep mat-button-toggle.drop-down-button .mat-button-toggle-appearance-standard .mat-button-toggle-label-content {
  background-color: rgb(96, 174, 222);
  padding: 0;
  line-height: 24px;
}
::ng-deep mat-button-toggle.drop-down-button:hover {
  background-color: rgb(96, 174, 222);
}
.buttonMenu {
  display: inline-flex;
  background-color: rgb(65, 65, 65);
  padding: 0;
}
::ng-deep {
}
::ng-deep .mat-button-toggle-appearance-standard .mat-button-toggle-label-content {
  padding: 0 !important;
  line-height: 35px !important;
}
@media (max-width: 1374px) {
  .home {
    display: none !important;
  }
}
a.navbar-brand {
  white-space: normal;
  text-align: center;
  word-break: break-all;
}
html {
  font-size: 14px;
}
@media (min-width: 768px) {
  html {
    font-size: 16px;
  }
}
.box-shadow {
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.05);
}
.mat-toolbar {
  background-color: rgb(65, 65, 65);
  font-size: small;
  padding: 0;
}
.breadcrumb {
  margin: 0;
  background-color: transparent;
  padding: 0;
  height: 62px;
}
.breadcrumb-item > a {
  color: white;
}
.breadcrumb-item.black > a {
  color: black;
}
.breadcrumb > li {
  display: flex !important;
  justify-content: center;
  align-items: center;
}
.breadcrumb-item.active {
  color: rgb(82, 168, 219);
}
.breadcrumb-item.active > a {
  color: rgb(82, 168, 219);
}
.vertical-line {
  border-left: 1px solid white;
  height: 36px;
  margin-left: 1px;
  margin-right: 1px;
  margin-top: 2px;
}
li.vertical-line {
  margin-top: 13px;
}
.mat-mdc-icon-button {
  border-radius: 0;
}
div.link:hover {
  cursor: pointer;
}
.btn-outline-primary:hover {
  background-color: rgb(96, 174, 222);
  border-color: rgb(96, 174, 222);
}
.btn-outline-primary {
  color: white;
  border-color: transparent;
}
.hidden {
  visibility: hidden;
}
::ng-deep .breadcrumb.actions [ngbtooltip=Abmelden],
::ng-deep .breadcrumb.actions .btn-outline-primary {
  border-radius: 0 !important;
}
::ng-deep .breadcrumb.actions [ngbtooltip=Abmelden] .mat-mdc-button-persistent-ripple,
::ng-deep .breadcrumb.actions .btn-outline-primary .mat-mdc-button-persistent-ripple {
  display: none !important;
}
::ng-deep .breadcrumb.actions [ngbtooltip=Abmelden] .mat-mdc-button-ripple,
::ng-deep .breadcrumb.actions .btn-outline-primary .mat-mdc-button-ripple {
  display: none !important;
}
::ng-deep .breadcrumb.actions [ngbtooltip=Abmelden] mat-icon,
::ng-deep .breadcrumb.actions .btn-outline-primary mat-icon {
  position: absolute !important;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
::ng-deep .mat-toolbar-row > .flex-container > button {
  border-radius: 0 !important;
}
::ng-deep .mat-toolbar-row > .flex-container > button .mat-mdc-button-persistent-ripple {
  display: none !important;
}
::ng-deep .mat-toolbar-row > .flex-container > button .mat-mdc-button-ripple {
  display: none !important;
}
::ng-deep [ngbtooltip=L\f6schen] {
  border-radius: 0 !important;
}
::ng-deep [ngbtooltip=L\f6schen] .mat-mdc-button-persistent-ripple {
  display: none !important;
}
::ng-deep [ngbtooltip=L\f6schen] .mat-mdc-button-ripple {
  display: none !important;
}
::ng-deep [ngbtooltip=Abmelden] mat-icon {
  position: absolute !important;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
::ng-deep mat-toolbar {
  position: relative;
  z-index: 999;
}
/*# sourceMappingURL=navtrail.component-PHWR5WNZ.css.map */
